import { render, staticRenderFns } from "./MyInsuranceCard.vue?vue&type=template&id=02e56eee"
import script from "./MyInsuranceCard.vue?vue&type=script&lang=js"
export * from "./MyInsuranceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports